<template>
  <div v-loading="loading">
    <div class="entry_banner">
      <img
        v-if="$store.state.wWidth > 768"
        src="../../assets/index-banner.png"
        alt
      />
      <img v-else src="../../assets/mobile/IndexBanner_Mobile@2x.png" alt />
      <div
        :class="`childPageTemp_title childPageTemp_title_${$i18n.locale}`"
      >
        <div>{{ $t($route.meta.lanCode) }}</div>
      </div>
    </div>
    <div class="entry entry_content">
      <EntryBtnGroup>
        <EntryBtn
          v-for="(entry, index) in entries.filter(
            (item) =>
              (item.forAccountApp && $store.state.isApp) || !$store.state.isApp
          )"
          :key="index"
          :icon="`${resourcePath}/public/api/v1/service-type-config/download/${entry.serviceType}`"
          :locale="entry.icon_local"
          :localIcon="entry.icon"
          :label="entry[`name${$t('message.lan')}`]"
          :disabled="entry.status != 'A'"
          :data="entry"
          :year="entry.year"
          @click="btnClick(entry)"
        ></EntryBtn>
      </EntryBtnGroup>
      <!-- v-if="$store.state.isApp" -->
      <!-- <div v-if="$store.state.isApp" style="text-align:center;">
        <el-button type="" style="margin" @click="getToken">getTokenTest</el-button>
        <el-button type="" style="margin" @click="getLan">getLanaguage</el-button>
      </div> -->
    </div>

    <!-- 條款彈窗 -->
    <el-dialog
      :visible.sync="termsDialogVisible"
      width="665px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :title="
        [
          'DRV_LIC_INTER',
          'SCHOOL_RENEW',
          'HEADMASTER_RENEW',
          'COACH_RENEW',
        ].includes(serviceType)
          ? $t('message.termsTitle2')
          : $t('message.termsTitle')
      "
      class="dialog_center_type trems_dialog"
    >
      <div class="modal-body">
        <div v-html="entry && entry.terms"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <GradientBtn @click="termsDialogVisible = false" white>{{
          $t("message.disagree")
        }}</GradientBtn>
        <GradientBtn @click="agree">{{ $t("message.agree") }}</GradientBtn>
      </span>
    </el-dialog>

    <!-- 文件列表彈窗 -->
    <el-dialog
      :visible.sync="filesDialogVisible"
      :title="$t('message.before_filling')"
      width="665px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      class="dialog_center_type files_dialog"
    >
      <div v-loading="loading">
        <ul class="documents_ul">
          <li
            v-for="item in documents"
            :key="item.id"
            :class="`${item.required ? 'my-is-required' : ''}`"
          >
            <label>{{ item[[`name${$t("message.lan")}`]] }}</label>
            <el-button
              v-if="item.sample"
              class="view_sample"
              type="warning"
              :size="$store.state.isMobile ? 'mini' : 'normal'"
              plain
              @click="downloadSample(item.id, item.sample.filename)"
              >{{ $t("message.view_sample") }}</el-button
            >
          </li>
        </ul>
      </div>
      <span slot="footer" class="dialog-footer">
        <GradientBtn @click="ready" :disabled="loading">{{
          $t("message.ready_to_filling")
        }}</GradientBtn>
      </span>
    </el-dialog>
    <pdfview
      v-if="showPdfView"
      :show="showPdfView"
      @close="showPdfView = false"
      :fileUrl="fileUrl"
      :fileType="fileType"
    ></pdfview>
  </div>
</template>

<script>
import { resourcePath } from "../../api/axios";
import EntryBtn from "../../components/EntryBtn";
import EntryBtnGroup from "../../components/EntryBtnGroup";
import GradientBtn from "../../components/GradientBtn";
import pdfview from "../../components/PdfView";
import DocumentTypeAPI from "../../api/DocumentTypeAPI";
import ServiceTypeConfigAPI from "../../api/ServiceTypeConfigAPI";
import safpBridgeObj from "../../plugins/govmo-js-sdk";
import { wordBreak } from "@/filters";
export default {
  components: { EntryBtn, EntryBtnGroup, GradientBtn, pdfview },
  data() {
    return {
      loading: false,
      resourcePath: resourcePath,
      entries: [],
      entry: {},
      termsDialogVisible: false,
      filesDialogVisible: false,
      documents: [],
      title: "",
      showPdfView: false,
      fileUrl: "",
      fileType: "",
      env: "",
      basePath: "",
    };
  },
  computed: {
    maintenance() {
      return function (value) {
        // return value;
        const date = new Date().getTime();
        const maintenanceStartTime = value.maintenanceStartTime
          ? new Date(value.maintenanceStartTime).getTime()
          : null;
        const maintenanceEndTime = value.maintenanceEndTime
          ? new Date(value.maintenanceEndTime).getTime()
          : null;
        return date >= maintenanceStartTime && date <= maintenanceEndTime;
      };
    },
    isTaxi() {
      return this.$route.name == "EntryTaxi" ? true : false;
    },
    serviceType() {
      return this.$store.state.serviceType;
    },
    locale() {
      return this.$i18n.locale;
    },
  },
  methods: {
    // app獲取token測試
    getToken() {
      safpBridgeObj.getToken({
        success(res) {
          alert("success:" + JSON.stringify(res));
        },
        fail(res) {
          alert("error:" + JSON.stringify(res));
        },
      });
    },
    // app獲取語言測試
    getLan() {
      alert(safpBridgeObj.getCurrentLanaguage());
    },
    // 點擊大按鈕
    btnClick(value) {
      if (value.serviceType === "HZMB_G_PTMT") {
        window.open(value.url);
        return;
      }
      this.termsDialogVisible = true;
      this.entry = value;
      this.$store.commit("changeServiceType", value.serviceType);
      this.$store.commit("changeServiceTypeConfig", value);
    },
    // 點擊同意
    agree() {
      this.termsDialogVisible = false;
      const businessType = this.$route.meta.businessType;
      if (
        ["TAXI", "DRV_LIC", "SCHOOL"].includes(businessType) ||
        [
          "HZMB_MO_RENEW_PERSON",
          "HZMB_MO_RENEW_COM",
          "HZMB_G_RENEW",
          "HZMB_G_CANCEL",
          "HZMB_H_CANCEL_PERSON",
          "HZMB_H_CANCEL_COMP",
          "HZMB_H_BOOKING",
          "HZMB_CHANGE_PERSON",
          "HZMB_CHANGE_COMP",
          "HZMB_GH_CHANGE_COMP",
        ].includes(this.serviceType)
      ) {
        // localStorage.setItem("serviceType", this.entry.serviceType);
        // this.$router.push('/personal');
        this.ready();
        return false;
      }
      setTimeout(() => {
        this.filesDialogVisible = true;
      }, 300);
      // 獲取文件列表
      const entry = this.entry;
      this.loading = true;
      DocumentTypeAPI.get(entry.serviceType)
        .then((res) => {
          this.loading = false;
          res.map((ele) => {
            ele.nameTc = wordBreak(ele.nameTc);
            ele.nameSc = wordBreak(ele.nameSc);
            ele.namePt = wordBreak(ele.namePt);
            ele.nameEn = wordBreak(ele.nameEn);
            return ele;
          });
          this.documents = res;
          if (
            [
              "HZMB_G_FIRST",
              "HZMB_H_FIRST_PERSON",
              "HZMB_H_FIRST_COMP",
            ].includes(this.serviceType)
          ) {
            if (!res.length) {
              this.ready();
            }
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    // 點擊已準備好
    ready() {
      localStorage.setItem("serviceType", this.entry.serviceType);
      if (this.entry.path == "/personal") {
        const accountToken = sessionStorage.getItem("accountToken") || null;
        if (accountToken) {
          this.$router.push({
            path: "/personal/onePass",
            query: {
              token: accountToken,
            },
          });
        } else {
          this.$router.push(this.entry.path);
        }
      } else {
        this.$router.push(this.entry.path);
      }
      console.log("🔨[ this.entry.path ]-294", this.entry);
      console.log("🔨[ this.entry.path ]-294", this.entry.path);
    },
    downloadSample(id, filename) {
      const getExtname = this.extname(filename);
      this.fileType = getExtname;

      if (this.$store.state.isMobile) {
        // if(getExtname.toLowerCase() == 'png' || getExtname.toLowerCase() == 'jpg' || getExtname.toLowerCase() == 'jpeg'){
        this.fileUrl = `${
          this.resourcePath
        }/public/api/v1/document-type/download/${id}${
          getExtname ? `.${getExtname}` : ""
        }`;
        this.showPdfView = true;
        // }else{
        // window.location.href = `${this.resourcePath}/public/api/v1/document-type/download/${id}${
        //     getExtname ? `.${getExtname}` : ""
        //   }`;
        // }
      } else {
        window.open(
          `${this.resourcePath}/public/api/v1/document-type/download/${id}${
            getExtname ? `.${getExtname}` : ""
          }`
        );
      }
    },
    getAllserviceType(businessType) {
      const entry = [
        {
          path: "/personal",
          icon: "HZMB_FIRST_PERSON.png",
          serviceType: "HZMB_FIRST_PERSON",
          year: true,
          terms: this.$t("message.terms_body"),
        },
        {
          path: "/company",
          icon: "HZMB_FIRST_COMPANY.png",
          serviceType: "HZMB_FIRST_COMPANY",
          year: true,
          terms: this.$t("message.terms_body"),
        },
        {
          path: "/personal",
          icon: "HZMB_MO_RENEW_PERSON.png",
          serviceType: "HZMB_MO_RENEW_PERSON",
          terms: this.$t("message.terms_body_hzmb_mo"),
        },
        {
          path: "/company",
          icon: "HZMB_MO_RENEW_COM.png",
          serviceType: "HZMB_MO_RENEW_COM",
          terms: this.$t("message.terms_body_hzmb_mo"),
        },
        {
          path: "/personal",
          icon: "HZMB_RENEW_PERSON.png",
          serviceType: "HZMB_RENEW_PERSON",
          terms: this.$t("message.terms_body2"),
        },
        {
          path: "/company",
          icon: "HZMB_RENEW_COMPANY.png",
          serviceType: "HZMB_RENEW_COMPANY",
          terms: this.$t("message.terms_body2"),
        },
        {
          path: "/hzmb-change-vd-personal",
          icon: "general_icon.png",
          serviceType: "HZMB_CHANGE_PERSON",
          terms: this.$t('hzmbChange.terms'),
        },
        {
          path: "/hzmb-change-vd-company",
          icon: "general_icon.png",
          serviceType: "HZMB_CHANGE_COMP",
          terms: this.$t('hzmbChange.terms'),
        },
        {
          path: "/hzmb-gh-change-vd-company",
          icon: "general_icon.png",
          serviceType: "HZMB_GH_CHANGE_COMP",
          terms: this.$t('hzmbChange.terms_bus'),
        },
        {
          path: "/personal",
          icon: "DriverPayment.png",
          serviceType: "TAXI_ANNUAL",
          terms: this.$t("message.terms_body3"),
        },
        {
          path: "/personal-type/DRV_LIC/DRV_LIC_INTER",
          icon: "DriverPayment.png",
          serviceType: "DRV_LIC_INTER",
          terms: this.$t("message.terms_body4"),
        },
        {
          path: "/personal-type/SCHOOL/SCHOOL_RENEW",
          icon: "SCHOOL_RENEW.png",
          serviceType: "SCHOOL_RENEW",
          terms: this.$t("school.terms_body_school"),
        },
        {
          path: "/personal-type/SCHOOL/HEADMASTER_RENEW",
          icon: "HEADMASTER_RENEW.png",
          serviceType: "HEADMASTER_RENEW",
          terms: this.$t("school.terms_body_staff"),
        },
        {
          path: "/personal-type/SCHOOL/COACH_RENEW",
          icon: "COACH_RENEW.png",
          serviceType: "COACH_RENEW",
          terms: this.$t("school.terms_body_staff"),
        },
        {
          path: "/hzmb-truck-hk-apply",
          icon: "general_icon.png",
          serviceType: "HZMB_G_FIRST",
          terms: this.$t("hzmbG.terms_hzmbG_first"),
        },
        {
          path: "/hzmb-truck-hk-cancel",
          icon: "general_icon.png",
          serviceType: "HZMB_G_CANCEL",
          terms: this.$t("hzmbG.terms_hzmbG_first"),
        },
        {
          url: "https://www.ptmt.gov.mo/rsWeb/login",
          icon: "ptmt.svg",
          icon_local: true,
          serviceType: "HZMB_G_PTMT",
        },
        {
          path: "/hzmb-truck-hk-insurance",
          icon: "general_icon.png",
          serviceType: "HZMB_G_INSURANCE",
          terms: this.$t("hzmbG.terms_hzmbG_first"),
        },
        {
          path: "/hzmb-truck-mo-personal",
          icon: "general_icon.png",
          serviceType: "HZMB_H_FIRST_PERSON",
          terms: this.$t("hzmbH.terms_hzmbH_first"),
        },
        {
          path: "/hzmb-truck-mo-company",
          icon: "general_icon.png",
          serviceType: "HZMB_H_FIRST_COMP",
          terms: this.$t("hzmbH.terms_hzmbH_first"),
        },
        {
          path: "/personal-type/HZMB/HZMB_H_RENEW_COMP",
          icon: "general_icon.png",
          serviceType: "HZMB_H_RENEW_COMP",
          terms: "跨境貨車，使用規章內容佔位",
        },
        {
          path: "/personal-type/HZMB/HZMB_H_RENEW_PERSON",
          icon: "general_icon.png",
          serviceType: "HZMB_H_RENEW_PERSON",
          terms: "跨境貨車，使用規章內容佔位",
        },
        {
          path: "/personal-type/HZMB/HZMB_H_CANCEL_PERSON",
          icon: "general_icon.png",
          serviceType: "HZMB_H_CANCEL_PERSON",
          terms: this.$t("hzmbH.terms_hzmbH_first"),
        },
        {
          path: "/personal-type/HZMB/HZMB_H_CANCEL_COMP",
          icon: "general_icon.png",
          serviceType: "HZMB_H_CANCEL_COMP",
          terms: this.$t("hzmbH.terms_hzmbH_first"),
        },
        {
          // 預約系統：跨境貨車及香港私家車轉乘 編號暫定：HZMB_H_BOOKING
          path: "/hzmb-truck-mo-booking",
          icon: "booking_icon.png",
          serviceType: "HZMB_H_BOOKING",
          terms: this.$t("hzmbH.terms_hzmbH_booking"),
        },
      ];
      this.loading = true;
      ServiceTypeConfigAPI.get(businessType)
        .then((res) => {
          this.loading = false;
          if (res && this.$store.state.isApp) {
            res = res.filter((item) => item.forAccountApp);
          }
          // 港珠澳配額，過濾掉其他的服務
          if (this.$route.name === "Entry") {
            res = res.filter((e) =>
              [
                "HZMB_FIRST_PERSON",
                "HZMB_FIRST_COMPANY",
                "HZMB_MO_RENEW_PERSON",
                "HZMB_MO_RENEW_COM",
                "HZMB_RENEW_PERSON",
                "HZMB_RENEW_COMPANY",
                "HZMB_CHANGE_PERSON",
                "HZMB_CHANGE_COMP",
              ].includes(e.serviceType)
            );
          }
          // 跨境客運
          if (this.$route.name === 'EntryBus') {
            res = res.filter((e) =>
              [
                "HZMB_RENEW_COMPANY",
                "HZMB_GH_CHANGE_COMP",
              ].includes(e.serviceType)
            );
          }
          // G類，過濾掉其他服務
          if (this.$route.name === "EntryHzmbG") {
            res = [
              ...res.filter((e) => ["HZMB_G_FIRST"].includes(e.serviceType)),
              {
                serviceType: "HZMB_G_PTMT",
                nameEn: "Macao Cross-Border Cargo Transfer Terminal Booking System",
                namePt:
                  "Sistema de Marcação do Posto de Transferência de Mercadorias Transfronteiriço de Macau",
                nameSc: "",
                nameTc: "預約轉運站",
                forAccountApp: true,
                online: true,
                maintenance: false,
                status: "A",
              },
              ...res.filter((e) =>
                ["HZMB_G_RENEW", "HZMB_G_CANCEL", "HZMB_G_INSURANCE"].includes(
                  e.serviceType
                )
              ),
            ];
          }
          console.log(res);
          // H類，過濾掉其他服務
          if (this.$route.name === "EntryHzmbH") {
            res = res.filter((e) =>
              [
                "HZMB_H_FIRST_PERSON",
                "HZMB_H_RENEW_PERSON",
                "HZMB_H_CANCEL_PERSON",
                "HZMB_H_FIRST_COMP",
                "HZMB_H_RENEW_COMP",
                "HZMB_H_CANCEL_COMP",
                "HZMB_H_BOOKING",
              ].includes(e.serviceType)
            );
          }
          // 國際駕照申請，過濾掉其他的服務
          if (businessType === "DRV_LIC") {
            res = res.filter(
              (e) =>
                !["DRV_LIC_SP_RENEW", "DRV_LIC_RENEW"].includes(e.serviceType)
            );
          }
          this.entries = res.map((item) => {
            item = {
              ...item,
              ...entry.find((ele) => ele.serviceType == item.serviceType),
            };
            item.nameTc = wordBreak(item.nameTc);
            item.nameSc = wordBreak(item.nameSc);
            item.namePt = wordBreak(item.namePt);
            item.nameEn = wordBreak(item.nameEn);
            return item;
          });
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    getServiceTypeDetails(serviceType) {
      const entry = {
        path: "/company",
        icon: "HZMB_RENEW_COMPANY.png",
        serviceType: "HZMB_RENEW_COMPANY",
        terms: this.$t("message.terms_body2"),
      };
      this.loading = true;
      ServiceTypeConfigAPI.getDetails(serviceType)
        .then((res) => {
          this.loading = false;
          if (res.status == "A") {
            res = {
              ...res,
              ...entry,
            };
            res.nameTc = wordBreak(res.nameTc);
            res.nameSc = wordBreak(res.nameSc);
            res.namePt = wordBreak(res.namePt);
            res.nameEn = wordBreak(res.nameEn);
            this.entries = [res];
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$error(err);
        });
    },
    // 截取文件類型
    extname(filename) {
      if (!filename || typeof filename != "string") {
        return "";
      }
      let a = filename.split("").reverse().join("");
      let b = a.substring(0, a.search(/\./)).split("").reverse().join("");
      return b;
    },
  },
  mounted() {
    const { code, message } = this.$route.query;
    if (code) this.$error({ status: 409, code, message });
  },
  created() {
    const basePath = process.env.VUE_APP_BASE_RESOURCE_PATH;
    this.basePath = basePath;
    // 一戶通APP下，無token跳轉一戶痛登陸
    if (this.$store.state.isApp && this.$route.query.token == "") {
      window.location.href = `${basePath}/protected/login-page/account?serviceType=${
        this.serviceType
      }&client=${this.serviceType}&Language=${this.$t("message.lang")}`;
    }

    // 設定標題
    this.title = this.$t(this.$route.meta.lanCode);
    this.$store.commit("changeViewType", "application");
    const businessType = this.$route.meta.businessType;
    if (businessType == "BUS") {
      this.getAllserviceType("HZMB");
    } else {
      this.getAllserviceType(businessType);
    }

    this.env = process.env.VUE_APP_ENV;

    // 的士繳費只顯示中文繁體
    // if(this.$route.path == '/entryTaxi' && this.$i18n.locale != 'ZH_TW'){
    //   this.$i18n.locale = 'ZH_TW';//只顯示中文繁體
    //   localStorage.setItem('lan','ZH_TW');
    //   location.reload();
    // }
    if (this.$route.meta.hidePT && this.$i18n.locale == "PT") {
      this.$i18n.locale = "ZH_TW"; //只顯示中文繁體
      localStorage.setItem("lan", "ZH_TW");
      location.reload();
    }
  },
};
</script>

<style lang="scss" scoped>
.entry {
  // max-width: 1440px;
  margin: auto;
}
.entry_banner {
  width: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    display: block;
  }
}
.entry_content {
  min-height: 450px;
  padding-top: 56px;
  padding-bottom: 45px;
  background: #f9f9f9;
}
// .documents_ul {
//   margin: 0;
//   padding: 0;
//   list-style: none;
// }
// .documents_ul li {
//   border-bottom: 1px solid #d8d8d8;
//   padding: 24px 0;
//   font-size: 20px;
//   font-weight: 400;
//   color: #3e4143;
//   line-height: 28px;
//   display: flex;
//   flex-direction: row;
//   align-items: center;
//   justify-content: space-between;
// }
// .documents_ul li label {
//   border-left: 4px solid #38959d;
//   padding-left: 32px;
//   display: block;
// }
.files_dialog {
  .gradient_btn {
    width: 443px;
    max-width: 100%;
  }
}
.childPageTemp_title {
  // justify-content: flex-end;
}
/deep/.el-dialog__body {
  padding: 0 20px 20px 20px !important;
}
/deep/.view_sample span {
  white-space: nowrap;
}
@media screen and (max-width: 767px) {
  // .documents_ul li {
  //   font-size: 16px;
  // }
  // .documents_ul li label {
  //   padding-left: 12px;
  //   padding-right: 12px;
  // }
  .gradient_btn {
    width: 100%;
  }
  .entry_content {
    padding-top: 24px;
    padding-bottom: 24px;
  }
  .entryBtn {
    margin-bottom: 12px !important;
  }
}
</style>
